import MainPage from './pages/MainPage';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import Privacy from './pages/Privacy';
import { useEffect } from 'react';

function App() {

  return (
    <>
      <Router>
        <Switch>
          <Route path="/" exact component={MainPage}/>
          <Route path="/privacy" component={Privacy}/>
        </Switch>
    </Router>
    </>
  );
}

export default App;
